<!-- <wpro-spinner-default *ngIf="((channels$ | async) === null) && (step !== PIN_STATE)"></wpro-spinner-default> -->
@if (step === CHANNEL_STATE && (channels$ | async)) {
  <wpro-verification-method
    [channels]="channels$ | async"
    (channel)="selectedChannel($event)"
  (apiError)="isVerified(false)"></wpro-verification-method>
}
@if (step === PIN_STATE) {
  <wpro-otp-form
    [method]="deliveryMethod"
    [value]="value"
    [useDiffMethodLink]="showDiffMethodLink"
    (changeChannel)="selectedChannel({ channel: $event, showDiffMethodLinkStatus: true })"
  (apiSuccess)="isVerified(true)"></wpro-otp-form>
}
